import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import { fetchLetterRelationSuccess } from '../actions/LetterRelation';
import { ILetterRelationArg } from '../../interfaces/LetterRelation';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

const geLetterRelation = async (params: ILetterRelationArg) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`letterRelation/GetLetterRelation`, { params });
};

function* fetchLetterRelationRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedLetterRelation = yield call(geLetterRelation, action.payload);
    yield put(fetchLetterRelationSuccess(fetchedLetterRelation.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterRelation() {
  yield takeEvery(ActionTypes.GET_LETTER_RELATION, fetchLetterRelationRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchLetterRelation)]);
}
